import styled from 'styled-components';
export const Container = styled.div`
  padding-top: 120px;
  padding-left: 8px;
  padding-right: 8px;
  display: flex;
  justify-content: center;
  background-color: #f2f2f2;
  font-family: 'Inter', sans-serif;
  @media (max-width: 600px) {
    padding-top: 117px;
  }
`;
export const InnerContainer = styled.div`
width: 60%;
padding: 50px;
background-color: #ffffff;
box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
margin: auto;
border-radius: 10px;
margin-bottom: 50px;
@media (max-width: 600px) {
  padding: 10px;
  width: 100%;
  margin-bottom: 50px;
}
`;
export const HeadingText = styled.div`
font-weight: 400;
font-size: 40px;
line-height: 1.5;
color: #202a36;
max-width: 884px;
margin-bottom: 20px;
@media (max-width: 600px) {
  font-size: 32px;
  line-height: 42px;
  }
`;
export const Text = styled.div`
  font-size: 1rem;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: 0.00938em;
  @media (max-width: 600px) {
    font-size: 1rem;
  }
`;


